import React from 'react'

import { Navigate, Route, Routes } from 'react-router-dom'

import { Paths } from 'common/routes'
import { Dashboard } from 'features/dashboard'
import { Exam } from 'features/exam'
import { Layout } from 'layout/Main'
import { Page404 } from 'layout/Page404/Page404'

export const AppRoutes = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="/" element={<Navigate to={Paths.Info} />} />
          <Route path={Paths.Info} element={<Dashboard />} />
          <Route path={Paths.Test} element={<Exam />} />
          <Route path="404" element={<Page404 />} />
          <Route path="*" element={<Navigate to="404" />} />
        </Route>
      </Routes>
    </>
  )
}
